export default "__VITE_ASSET__B5hVOAzl__"